import { IdentityWithoutIds } from '../base/identity';

export class HorseIdentityWithoutIds extends IdentityWithoutIds {

    constructor(params?: Partial<HorseIdentityWithoutIds>) {
        super(params);
    }

}
